// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseModal_root__MpGMB"};